import React, { Component } from "react";
import { getValue } from "../utils/models";
import { Row, Col } from "antd";
import AutoInput from "../containers/AutoInput";
import withValues from "../hocs/withValues";

class TermsAndConditionsCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: null,
      type: null,
      dueDate: null,
      content: null,
    };
  }

  componentWillMount() {}

  componentDidUpdate(prevProps) {
    const props = [
      "name",
      "type",
      "dueDate",
      "content",
    ];
    props.forEach(prop => {
      if (this.props.values[prop] !== prevProps.values[prop]) {
        this.setState({
          [prop]: getValue(this.props.values, prop)
        });
      }
    });
  }

  render() {
    return (
      <Row gutter={10}>
        <Col span={24}>
          <AutoInput
            form={this.props.form}
            model={"termsandconditions"}
            attribute={"name"}
            autoSave
            value={getValue(this.props.values, "name")}
          />
        </Col>
        <Col span={24}>
          <AutoInput
            form={this.props.form}
            model={"termsandconditions"}
            attribute={"type"}
            autoSave
            value={getValue(this.props.values, "type")}
          />
        </Col>
        <Col span={24}>
          <AutoInput
            form={this.props.form}
            model={"termsandconditions"}
            attribute={"dueDate"}
            autoSave
            value={getValue(this.props.values, "dueDate")}
          />
        </Col>
        <Col span={24}>
          <AutoInput
            form={this.props.form}
            model={"termsandconditions"}
            attribute={"version"}
            autoSave
            value={getValue(this.props.values, "version")}
          />
        </Col>
        <Col span={24}>
          <AutoInput
            form={this.props.form}
            model={"termsandconditions"}
            attribute={"content"}
            autoSave
            value={getValue(this.props.values, "content")}
          />
        </Col>
      </Row>
    );
  }
}

export default withValues(TermsAndConditionsCreate);



// WEBPACK FOOTER //
// ./src/forms/TermsAndConditionsCreate.js